import React from "react";
import tutorialDashboardIcon from "../../../../../assets/images/tutorialDashboardIcon.svg";
import "./TutorialInsightfull.css";

const TutorialInsightfull = ({ title, description }) => {
  return (
    <div className="tutorialContentBox TutorialInsightfullContentBox">
      <div className="imgBtnBox">
        <img
          alt="tutorialDashboardIcon"
          className="TutorialInsightfullImg"
          src={tutorialDashboardIcon}
        />
      </div>
      <p className="title">{title}</p>
      <p className="desc">{description}</p>
    </div>
  );
};

export default TutorialInsightfull;
